module.exports = __webpack_public_path__ + "img/Cobo Wallet.43880b67.png";